import { Categories } from "@/helpers/constants";
import { EpgItem } from "@/services/apiService/api.types";

export enum ViewType {
  ChannelLogo = "ChannelLogo",
  ChannelEpg = "ChannelEpg"
}

export const enum ChannelsPageAction {}

export const enum ChannelsPageMutation {
  setCardControls = "setCardControls",
  setPlayedChannelId = "setPlayedChannelId",
  setPlayedChannelIndex = "setPlayedChannelIndex",
  setPlayedChannelCategory = "setPlayedChannelCategory",
  setPlayedChannelView = "setPlayedChannelView",
  setActiveChannelOverlayInfo = "setActiveChannelOverlayInfo",
  setActiveInfoScreenEpgItem = "setActiveInfoScreenEpgItem",
  setShowInfoScreen = "setShowInfoScreen",
  setShowEpgScreen = "setShowEpgScreen"
}

export const enum ChannelsPageGetter {
  GetCardControls = "GetCardControls",
  GetPlayedChannelId = "GetPlayedChannelId",
  GetPlayedChannelIndex = "GetPlayedChannelIndex",
  GetPlayedChannelCategory = "GetPlayedChannelCategory",
  GetPlayedChannelView = "GetPlayedChannelView",
  getActiveChannelOverlayInfo = "getActiveChannelOverlayInfo",
  getActiveInfoScreenEpgItem = "getActiveInfoScreenEpgItem",
  getShowInfoScreen = "getShowInfoScreen",
  getShowEpgScreen = "getShowEpgScreen"
}
export interface ChannelsPageState {
  cardControls: boolean;
  playedChannelId?: number;
  playedChannelIndex?: number;
  playedChannelCategory?: Categories;
  playedChannelView?: ViewType;
  activeChannelOverlayInfo?: InfoChannelData;
  activeInfoScreenEpgItem?: EpgItem;
  showInfoScreen: boolean;
  showEpgScreen: boolean;
}

export interface InfoChannelData {
  channelName: string;
  channelId: number;
  channelCatchup: boolean;
}

export enum ModalType {
  InfoModal = "InfoModal",
  EpgModal = "EpgModal"
}
